export default "__VITE_ASSET__33ef83d5__"